import React from "react";
import FieldLabel from "../../../components/label";
import ChipSelect from "../../../components/chipSelect";
import NomineeBankDetailsForm from "./bankForm";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, Stack, Typography } from "@mui/material";
import { isNomineeBankDetailsMissing } from "../../../helpers/nominee";

function NomineeBankDetails({
  classes: { accordianSection, contentScroller, formGroup },
  banks = [],
  errorMessage,
  form,
  handleAccordionChange,
  handleChange,
  handleChangeChipSelect,
  options,
  section,
  selectedBankOption,
  setSelectedBankOption,
  validateInputLength,
}) {
  return (
    <>
      <Box
        className={accordianSection}
        onClick={() =>
          handleAccordionChange("nomineeBank", section.nomineeBank)
        }
      >
        <Stack
          direction="row"
          gap={1}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {isNomineeBankDetailsMissing(
            form,
            errorMessage,
            selectedBankOption
          ) && <NewReleasesOutlinedIcon />}
          {!isNomineeBankDetailsMissing(
            form,
            errorMessage,
            selectedBankOption
          ) && <CheckCircleOutlineIcon sx={{ color: "green" }} />}
          <Typography variant="subtitle2">Nominee Bank Details</Typography>
        </Stack>
        <Box>
          {!section.nomineeBank && <ExpandMoreIcon fontSize="medium" />}
          {section.nomineeBank && <ExpandLessIcon fontSize="medium" />}
        </Box>
      </Box>

      {section.nomineeBank && (
        <Box p={1} mt={0} sx={{ height: "364px" }} className={contentScroller}>
          <Box className={formGroup} pt={0}>
            <FieldLabel label={"Nominee Bank Details*"} />
            <ChipSelect
              fieldname={"nominee_bank_details_available"}
              handleChange={handleChangeChipSelect}
              options={options.availableOrNot}
              selectedItem={form.nominee_bank_details_available}
              isMinWidth={true}
            />
          </Box>

          {form.nominee_bank_details_available === "Available" && (
            <>
              <Box className={formGroup} pt={0}>
                <FieldLabel label={"Same as the Owner of the Policy*"} />
                <ChipSelect
                  fieldname={"nominee_bank_details_same_as_owner"}
                  handleChange={handleChangeChipSelect}
                  options={options.sameOrDifferent}
                  selectedItem={form.nominee_bank_details_same_as_owner}
                  isMinWidth={true}
                />
              </Box>

              {form.nominee_bank_details_same_as_owner === "Different" && (
                <NomineeBankDetailsForm
                  banks={banks}
                  errorMessage={errorMessage}
                  form={form}
                  handleChange={handleChange}
                  handleChangeChipSelect={handleChangeChipSelect}
                  options={options}
                  selectedBankOption={selectedBankOption}
                  setSelectedBankOption={setSelectedBankOption}
                  validateInputLength={validateInputLength}
                />
              )}
            </>
          )}
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(NomineeBankDetails);
